module.exports = __webpack_public_path__ + "a2e26b8c4c4c6f3054af9eca90a12a8a.jpg";